import React, { useState } from "react"
/**
 * @param props {{
 *  scState:scState
 * }}
 */
export default function RightSideSelectedFile({ scState }) {
  var [isOpen,set_isOpen]=useState(false)
  function clickFile(path){
    scState.set_selectedFile(path)
    set_isOpen(false)
  }
  return <div css={`
    display:flex;
    flex-direction:column;
    cursor:pointer;
    position:relative;
  `}><div
  onClick={()=>set_isOpen(!isOpen)}
  css={`
      background-color:white;
      font-size:14px;
      display:flex;
      justify-content:space-between;
      align-items:center;
      width:100%;
      padding:7px;
  `}>
      <div>
        {scState.selectedFile}
      </div>
      <div>
        <img src="/down-black.png" height="18" />
      </div>
    </div>
    {isOpen && <div>
      <div css={`
          width:100%;
          max-height:300px;
          overflow-x:hidden;
          overflow-y:scroll;
          z-index:10;
          position:absolute;
      `}>
        {scState.solFiles.map(({path})=>
          <div 
            onClick={()=>clickFile(path)}
            css={`
              background-color:white;
              font-size:14px;
              width:100%;
              padding:7px;
              :hover {
                background-color:#eee
              }
          `}
          key={path}>{path}</div>
        )}
      </div>
    </div>}
  </div>
}